import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Paginator } from "../../models/paginator";
import { MatMiniFabButton } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { MatIconModule } from "@angular/material/icon";


@Component({
  selector: 'api-paginator',
  providers: [],
  styleUrls: ['./api-paginator.scss'],
  standalone: true,
  imports: [
    MatMiniFabButton,
    MatTooltipModule,
    TranslateModule,
    MatIconModule
  ],
  templateUrl: './api-paginator.html'
})
export class ApiPaginator implements OnInit {

  constructor() {
  }

  @Input()
  public paginatorFromAPi: Paginator = {} as Paginator;
  @Output()
  public goToFirstPage: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  public goToPreviousPage: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  public goToNextPage: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  public goToLastPage: EventEmitter<void> = new EventEmitter<void>();

  public ngOnInit() {
    // Logique pour initialiser le composant
  }

  public handleGoToFirstPage(): void {
    this.goToFirstPage.emit();
  }

  public handleGoToPreviousPage(): void {
    this.goToPreviousPage.emit();
  }

  public handleGoToNextPage(): void {
    this.goToNextPage.emit();
  }

  public handleGoToLastPage(): void {
    this.goToLastPage.emit();
  }

}
